import { Component } from '@angular/core';
import { ImportedFilesListComponent } from '@src/base-components/management/imported-files-list/imported-files-list.component';

@Component({
    selector: 'app-imported-files-list-messika',
    templateUrl: './imported-files-list-messika.component.html',
    styleUrls: ['../../../../base-components/management/imported-files-list/imported-files-list.component.scss']
})
export class ImportedFilesListMessikaComponent extends ImportedFilesListComponent {}
